import { useNavigate } from "@tanstack/react-router";
import { useState, type FormEvent } from "react";
import { Botao } from "../componentes/kit/Botao";
import { Campo } from "../componentes/kit/Campo";
import { supabase } from "../sessao/supabase";

export function Entrar() {
  const navegar = useNavigate();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setEnviando(true);
    setErro(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password: senha });
    setEnviando(false);
    if (error) return setErro("E-mail ou senha não conferem.");
    await navegar({ to: "/" });
  }

  return (
    <div className="grid min-h-full place-items-center bg-fundo px-4 py-8">
      <form onSubmit={enviar} className="w-full max-w-sm rounded-cartao fio bg-superficie p-6">
        <div className="mb-6 flex items-center gap-3">
          <span aria-hidden className="grid size-8 place-items-center rounded-controle bg-acao font-medium text-acao-texto">F</span>
          <div>
            <h1 className="font-medium text-texto-1">F&amp;A Gestão</h1>
            <p className="text-meta text-texto-3">Freitas e Agostini Advocacia</p>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <Campo rotulo="E-mail" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Campo rotulo="Senha" type="password" required autoComplete="current-password" value={senha} onChange={(e) => setSenha(e.target.value)} erro={erro} />
          <Botao type="submit" variante="primario" grande carregando={enviando} className="mt-2 w-full">
            {enviando ? "Entrando…" : "Entrar"}
          </Botao>
        </div>
      </form>
    </div>
  );
}
